<template>
    <div id="pagina-sempermissao-page">
      <br />
      <br />
      <div id="pagina-sempermissao-container">
        <div id="pagina-sempermissao-container-titulo-oops">
          <div class="display-4 text-danger" style="text-align: center">
            <i class="fas fa-ban"></i>
          </div>
          <div id="pagina-sempermissao-titulo-oops" class="text-danger">
            Oops!
          </div>
          <div id="pagina-sempermissao-titulo-msg" class="px-2">
            Você não pode acessar esta tela sem estar logado!
          </div>
        </div>
      </div>
  
      <div id="pagina-sempermissao-page-container">
        <div id="pagina-sempermissao-container-nome-app">
          <div id="pagina-sempermissao-nome-app-linxmicrovix">Linx Microvix</div>
          <div id="pagina-sempermissao-nome-app-vendafacil">Agenda Online</div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "SemPermissao",
    computed: {},
  };
  </script>
  
  <style scoped>
  #pagina-sempermissao-page {
    height: 98vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  #pagina-sempermissao-container {
    flex-grow: 9;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
  }
  
  #pagina-sempermissao-container-titulo-oops {
    flex-grow: 1;
    text-align: right;
  }
  
  #pagina-sempermissao-titulo-oops {
    font-size: 4rem !important;
    font-weight: bolder;
    font-family: Dosis, sans-serif;
    color: #5b2e90;
    text-align: center;
    margin-top: -30px !important;
  }
  
  #pagina-sempermissao-container-titulo-msg {
    flex-grow: 1;
    text-align: left;
    text-align: center;
  }
  
  #pagina-sempermissao-titulo-msg {
    font-size: 1.5rem !important;
    font-family: Dosis, sans-serif;
    color: #5b2e90;
    text-align: center;
  }
  
  #pagina-sempermissao-nome-app-linxmicrovix {
    text-align: center;
    font-family: Dosis, sans-serif;
    font-size: 2rem;
    color: #ffb200;
  }
  
  #pagina-sempermissao-nome-app-vendafacil {
    text-align: center;
    font-family: Dosis, sans-serif;
    font-weight: bold;
    font-size: 2rem;
    color: #5b2e90;
  }
  
  .btn {
    line-height: 1.5 !important;
  }
  
  #btn-sair {
    width: 200px;
    position: relative;
  }
  
  @media only screen and (max-width: 600px) {
    #btn-sair {
      display: block !important;
      width: 100% !important;
    }
  }
  </style>
  